import { ServerConnection, Session } from "@jupyterlab/services";
import { merge } from "@/utils/tools";
import { standardRendererFactories } from "@jupyterlab/rendermime";

/**
 * 获取内核
 * @param kernelOptions
 * @returns {Promise<Session.ISession>}
 */
export const requestKernel = kernelOptions => {
    kernelOptions = merge({ kernelOptions }).kernelOptions;
    if (kernelOptions.serverSettings) {
        let ss = kernelOptions.serverSettings;
        if (ss.baseUrl && !ss.wsUrl) {
            ss.wsUrl = "ws" + ss.baseUrl.slice(4);
        }
        kernelOptions.serverSettings = ServerConnection.makeSettings(
            kernelOptions.serverSettings
        );
    }
    let p = Session.startNew(kernelOptions);
    p.then(session => {
        let k = session.kernel;
        return k;
    });
    return p;
};

export const getRenderers = options => {
    let _renderers = undefined;
    if (!_renderers) {
        _renderers = standardRendererFactories.filter(f => {
            // filter out latex renderer if mathjax is unavailable
            if (f.mimeTypes.indexOf("text/latex") >= 0) {
                if (options.mathjaxUrl) {
                    return true;
                } else {
                    // eslint-disable-next-line
                    console.log("MathJax unavailable");
                    return false;
                }
            } else {
                return true;
            }
        });
    }
    return _renderers;
};
